import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, ApplicationEventFilterAreaInteractionType } from '../constants';


export class FilterAreaInteractionApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.FilterAreaInteraction;

  constructor(
    private interactionType: ApplicationEventFilterAreaInteractionType
  ) {
  }

  getPayload(): any {
    return {
      type: this.interactionType,
    };
  }
}
